import ctl from '@netlify/classnames-template-literals';

const buttonContainer = ctl(`
  w-full
  text-left
  flex
  hover:bg-silver-sand
`);

export default {
  buttonContainer,
};
